  /**
   * Author: Neeti
   * Project: Ludo Board Game
   * Copyright: Moblize.IT LLC | All rights reserved
   * Last Modified: Apr 12 2020
   * 
   * Description: The init app component file 
   * 
   */
import { Component } from '@angular/core';

import { Platform, NavParams } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private activatedRoute: ActivatedRoute
    ) {
    this.initializeApp();
  }

  initializeApp() {
  }
}
